<template>
  <div>
      <div class="layer1 flex-col justify-center">
        <div class="group1 flex-col justify-center">
          <div class="block1 flex-row justify-center">
            <div class="bd1 flex-col">
              <span class="infoBox1">天际助手，<br />帮你节省50%工作时间</span>
              <span class="infoBox2">一站式建模开发赋能，SQL跟踪、性能检测、规则<br />测试、聚合指引文档，最佳案例，代码片段复用</span>
              <div class="infoBox3 flex-row">
                <a class="infoButton3 flex-col" href="/media/modeling-developer-console.zip" download="modeling-developer-console.zip">
                  <span class="download">立即下载</span>
                </a>
                <a class="infoLink flex-col" href="https://www.google.cn/chrome/" target="_blank">下载 chrome 浏览器</a>
              </div>
            </div>
            <div class="bd2 flex-col justify-center align-center">
              <img
                      class="pic pic2"
                      referrerpolicy="no-referrer"
                      src="../assets/screenshoot.png"
                      @click="openVideoModal"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="layer2 flex-row justify-center align-center">
        <div class="group1 flex-col">
          <img class="pic pic1" src="../assets/section1.png" alt="页面请求执行SQL快速查看">
        </div>
        <div class="group2 flex-col justify-between">
          <span class="infoBox1">页面请求执行SQL快速查看</span>
          <span class="infoBox2"
          >F12快速查看后端请求执行脚本和执行时间，<br />一键复制脚本直接执行。</span
          >
        </div>
      </div>
      <div class="layer3 flex-col align-center">
        <div class="group1 flex-row justify-between">
          <div class="block1 flex-col justify-between">
            <span class="infoBox1">页面、控件、环境信息一键查看</span>
            <span class="infoBox2"
            >右键或者通过建模助手快速查看当前环境信息，<br />页面布局、控件、数据源信息快速穿透设计器。</span
            >
          </div>
          <div class="block2 flex-col">
            <img class="pic" src="../assets/section2.png" />
          </div>
        </div>
      </div>
      <div class="layer4 flex-row justify-center">
        <div class="group1 flex-col">
          <img class="pic" src="../assets/section3.png" />
        </div>
        <div class="group2 flex-col justify-between">
          <span class="infoBox1">聚合指引文档、最佳案例、代码片段</span>
          <span class="infoBox2">聚合指引文档，更懂你的助手，<br />大量最佳案例，代码片段教你做一个优秀的伸手党。</span>
        </div>
      </div>
    <el-dialog v-model="openStatus">
      <video src="../assets/guide1.mp4" controls="controls" autoplay></video>
    </el-dialog>
  </div>
</template>
<script>
  import { ElDialog } from 'element-plus'
  export default {
    name: 'HomePage',
    components :{
      ElDialog
    },
    data() {
      return {
        openStatus: false,
      };
    },
    methods: {
      downloadZip() {
        window.open('https://tools.mingyuanyun.com/tools/modelingConsole/file/modeling-developer-console-v1.0.4.zip')
      },
      openVideoModal() {
        this.openStatus = true
      }
    },
  };
</script>
